import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

const ACCENT = '#60A5FA';

const ACCOUNT_TYPES = [
  { value: 'checking', label: 'Checking' },
  { value: 'savings', label: 'Savings' },
  { value: 'credit', label: 'Credit Card' },
  { value: 'cash', label: 'Cash' },
  { value: 'crypto', label: 'Cryptocurrency' },
  { value: 'other', label: 'Other' },
];

const emptyAccount = () => ({
  bank: '',
  account_type: 'checking',
  total_balance: '0',
  iban: '',
  card_number: '',
});

const BankAccountModal = ({ show, onHide, onSubmit, initialData = null }) => {
  const [account, setAccount] = useState(emptyAccount());

  useEffect(() => {
    if (!show) return;
    if (initialData) {
      setAccount({
        bank: initialData.bank || '',
        account_type: initialData.account_type || 'checking',
        total_balance: String(initialData.total_balance ?? '0'),
        iban: initialData.iban || '',
        card_number: initialData.card_number || '',
      });
    } else {
      setAccount(emptyAccount());
    }
  }, [show, initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      bank: account.bank.trim(),
      account_type: account.account_type,
      total_balance: parseFloat(account.total_balance) || 0,
      iban: account.iban.trim() || null,
      card_number: account.card_number.trim() || null,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccount((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={show} onHide={onHide} centered contentClassName="bg-dark text-light">
      <Modal.Header closeButton closeVariant="white" style={{ borderBottom: '1px solid #333' }}>
        <Modal.Title>{initialData ? 'Edit Account' : 'Add Account'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Account name</Form.Label>
            <Form.Control
              type="text"
              name="bank"
              value={account.bank}
              onChange={handleChange}
              required
              placeholder="e.g. Piraeus, Cash, Revolut"
              className="bg-dark text-light border-secondary"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Select
              name="account_type"
              value={account.account_type}
              onChange={handleChange}
              required
              className="bg-dark text-light border-secondary"
            >
              {ACCOUNT_TYPES.map((type) => (
                <option key={type.value} value={type.value}>{type.label}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {initialData ? 'Current balance (€)' : 'Starting balance (€)'}
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="total_balance"
              value={account.total_balance}
              onChange={handleChange}
              required
              className="bg-dark text-light border-secondary"
            />
            {initialData && (
              <Form.Text style={{ color: '#9ca3af' }}>
                Balance also updates automatically when you log transactions.
              </Form.Text>
            )}
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>IBAN (optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="iban"
                  value={account.iban}
                  onChange={handleChange}
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Card number (optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="card_number"
                  value={account.card_number}
                  onChange={handleChange}
                  maxLength={16}
                  className="bg-dark text-light border-secondary"
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #333' }}>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button variant="primary" type="submit" style={{ backgroundColor: ACCENT, borderColor: ACCENT }}>
            {initialData ? 'Save' : 'Create'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default BankAccountModal;
